import * as React from 'react';
import { DataGrid } from 'ui-toolkit';
import { getOrderColumns } from '../data/OrderDataGridColumns';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';
import { ISearchOrderData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export interface IOrdersProps {
  orders: ISearchOrderData[];
  userType: eAccessControlUserType;
  loading: boolean;
  onSortChange: (field: string, sort: 'asc' | 'desc') => void;
}

const Orders: React.FC<IOrdersProps> = ({ orders, loading, userType, onSortChange }) => {
  const columns: IBootstrapTableColumnProps<ISearchOrderData>[] = getOrderColumns(userType, onSortChange);

  return (
    <DataGrid
      data={orders}
      defaultSorted={[{ dataField: 'createdAt', order: 'desc' }]}
      columns={columns}
      keyField={'orderId'}
      loading={loading}
    />
  );
};

export default Orders;
